export default __webpack_public_path__ + "static/media/courseLanding-whatsApp.3969b664.png";